module.exports = __webpack_public_path__ + "img/_16.1a67970d.png";